import { BASE_URL } from '@constants/environment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Icon, Button } from '@devfolioco/genesis';
import { Analytics } from '@devfolioco/helpers';
import React from 'react';
import styled from 'styled-components';

import Tooltip from 'components/Tooltip';

import { history } from 'helpers/history';
import { ANALYTICS_TRACKING_EVENTS } from '@constants';

export const FloatingButtons = styled.div`
  position: absolute;
  right: -72px;
  top: 58px;
  display: flex;
  flex-direction: column;

  button {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    padding: 0;
    margin-bottom: 24px;
  }

  @media (max-width: 650px) {
    position: fixed;
    right: 28px;
    top: initial;
    bottom: 40px;
  }
`;

const routeToProfile = () => {
  history.push('/profile');
};

const ActionBar = ({ username, myUsername }) => {
  // show edit if user is logged in
  const showEdit =
    typeof username === 'string' &&
    typeof myUsername === 'string' &&
    username.toLowerCase() === myUsername.toLowerCase();

  const [hasCopied, updateHasCopied] = React.useState(false);

  React.useEffect(() => {
    if (hasCopied) {
      setTimeout(() => {
        updateHasCopied(false);
      }, 1000);
    }
  }, [hasCopied]);

  const handleCopy = () => {
    Analytics.trackEvent(ANALYTICS_TRACKING_EVENTS.COPIED_DEVFOLIO_PROFILE_LINK, {
      username,
    });
    updateHasCopied(!hasCopied);
  };

  return (
    <FloatingButtons>
      <Tooltip data={() => (hasCopied ? `Copied` : `Copy link`)} style={{ width: 120 }}>
        {() => (
          <CopyToClipboard text={`${BASE_URL}@${username}`} onCopy={handleCopy}>
            <Button title="Copy Devfolio link">
              <Icon name="copy" />
            </Button>
          </CopyToClipboard>
        )}
      </Tooltip>

      {showEdit && (
        <Tooltip data={() => 'Edit my profile'} style={{ width: 160 }}>
          {() => (
            <Button title="Edit Devfolio" onClick={routeToProfile}>
              <Icon name="pencil" />
            </Button>
          )}
        </Tooltip>
      )}
    </FloatingButtons>
  );
};

export default React.memo(ActionBar);
